import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import { LoginUserApi, ForgotPasswordApi } from "../../Code/Data";

export default class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      message: null,
    };

    this.doLogin = this.doLogin.bind(this);
    this.doForgotPassword = this.doForgotPassword.bind(this);
  }

  async doLogin() {
    this.setState({ message: null });
    let { email, password } = this.state;
    if (!(email && email.length)) {
      this.setState({ message: 'Please enter your login email address.' });
      return;
    }
    if (!(password && password.length)) {
      this.setState({ message: 'Please enter your password.' });
      return;
    }
    let request = { email, password };
    console.log("LOGIN REQUEST", request);
    let response = await LoginUserApi(request);
    console.log("LOGIN RESPONSE", response);
    if (response.Succeeded) {
      if (this.props.onSuccess) {
        this.props.onSuccess(response.User);
      } else {
        window.location.reload();
      }
    } else {
      this.setState({ message: response.ErrorMessage });
    }
  }

  async doForgotPassword() {
    let { email } = this.state;
    if (email && email.length) {
      this.setState({ message: null });
    } else {
      this.setState({ message: 'Please enter an email.' });
      return;
    }
    console.log("FORGOT PASSWORD REQUEST", email);
    let response = await ForgotPasswordApi(email);
    console.log("FORGOT PASSWORD RESPONSE", response);
    if (response.Succeeded) {
      this.setState({ message: `We've emailed you a link to reset your password` });
    } else {
      this.setState({ message: response.ErrorMessage });
    }
  }

  render() {
    const { isOpen, onClose } = this.props;
    const { email, password, message } = this.state;

    return (
      <Modal isOpen={isOpen} toggle={onClose} className="login-modal" size="lg">
        <ModalHeader>Log In to Check Out!</ModalHeader>
        <ModalBody>
          <Container>
            <Row className="justify-content-around">
              <Col md={6}>
                <FormGroup className="has-float-label">
                  <Input
                    type="text"
                    id="email"
                    placeholder=" "
                    value={email}
                    onChange={e => this.setState({ email: e.target.value })}
                  />
                  <Label for="email">Email</Label>
                </FormGroup>
                <FormGroup className="has-float-label">
                  <Input
                    type="password"
                    id="password"
                    placeholder=" "
                    value={password}
                    onChange={e => this.setState({ password: e.target.value })}
                  />
                  <Label for="password">Password</Label>
                </FormGroup>
                <a href="javascript:void(0);" onClick={this.doForgotPassword}>I forgot my password</a>
                <Button color="primary" onClick={this.doLogin} block={true}>
                  Login
                </Button>
                <br />
                <Alert
                  color="danger"
                  isOpen={!!message}
                  toggle={() => this.setState({ message: null })}>
                  <p>
                    {message}
                  </p>
                </Alert>
              </Col>
              <Col md={6}>
                <Button color="primary" href="/Login.aspx?ReturnPage=^Purchase^ShoppingCart" block={true}>
                  Create Personal Account
                </Button>
                <Button color="primary" href="/Login.aspx?CA=1&ReturnPage=^Purchase^ShoppingCart" block={true}>
                  Create Corporate Account
                </Button>
              </Col>
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}
